import { parseApiTimestampToUnixMs } from './parse-api-timestamp-to-unix-ms';

/** GraphQL / RPC 由来の日時を ISO 文字列へ。公開 URL のキャッシュバスト用。 */
export function normalizeCacheBustTimestamp(value: unknown): string | null {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    const ms = value.getTime();
    return Number.isNaN(ms) ? null : value.toISOString();
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    const ms = value < 1e12 ? value * 1000 : value;
    const d = new Date(ms);
    return Number.isNaN(d.getTime()) ? null : d.toISOString();
  }
  const raw = typeof value === 'string' ? value : String(value);
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const ms = parseApiTimestampToUnixMs(trimmed);
  if (ms == null) return trimmed;
  return new Date(ms).toISOString();
}
